import { useContext } from 'react';
import { MutualContext, MutualContextType } from '../contexts/mutual_context';

const useMutual = () => {
    return useContext(MutualContext) as MutualContextType;
};

export default useMutual;
